export enum ScrollDirection {
  None = 'none',
  Up = 'up',
  Down = 'down'
}

export function useScrollDirection(
  threshold: number = 0,
  idleDelay: number = 150
): {
  direction: Ref<ScrollDirection>
  y: Ref<number>
} {
  const direction = ref<ScrollDirection>(ScrollDirection.None)
  const y = ref<number>(0)

  let lastY = 0
  let ticking = false
  let idleTimeout: number | null = null

  function update() {
    const currentY = window.scrollY || document.documentElement.scrollTop
    const delta = currentY - lastY

    if (Math.abs(delta) > threshold) {
      if (delta > 0) {
        direction.value = ScrollDirection.Down
      } else {
        direction.value = ScrollDirection.Up
      }
      lastY = currentY <= 0 ? 0 : currentY
    }

    y.value = currentY
    ticking = false

    if (idleTimeout) clearTimeout(idleTimeout)
    idleTimeout = window.setTimeout(() => {
      direction.value = ScrollDirection.None
    }, idleDelay)
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update)
      ticking = true
    }
  }

  onMounted(() => {
    y.value = window.scrollY || document.documentElement.scrollTop
    lastY = y.value
    window.addEventListener('scroll', onScroll, { passive: true })
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
    if (idleTimeout) clearTimeout(idleTimeout)
  })

  return { direction, y }
}
